import { UAParser } from 'ua-parser-js'

const parser = new UAParser()

export const isUsingSupportedBrowser = () => {
  const { os = null, browser = null } = parser.getResult() || {}

  if (!browser || !browser.version) {
    return true
  }

  const majorVersion = Number(browser.version.split('.')[0])

  if (browser.name && browser.name.toLowerCase() === 'ie') {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'edge' &&
    majorVersion <= 92
  ) {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'chrome' &&
    majorVersion <= 89
  ) {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'firefox' &&
    majorVersion <= 89
  ) {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'samsung browser' &&
    majorVersion < 16
  ) {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'safari' &&
    majorVersion < 14
  ) {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'safari mobile' &&
    majorVersion < 14
  ) {
    return false
  }

  if (
    browser.name &&
    browser.name.toLowerCase() === 'ios' && // safari in iOS (mobile) is detected as 'ios' browser
    os &&
    os.name &&
    os.name.toLowerCase() === 'ios' &&
    majorVersion < 14
  ) {
    return false
  }

  return true
}

export const getDomainName = (hostname: string) => {
  if (hostname.includes('localhost')) {
    return hostname
  }

  const matchedDomain = hostname.match(/[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/)

  return matchedDomain ? matchedDomain[0] : hostname
}

export const getBrowser = () => parser.getBrowser()

export const getOS = () => parser.getOS()
